export const numberToWords = (amount) => {
    const a = [
        '', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ',
        'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ',
        'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ',
        'Seventeen ', 'Eighteen ', 'Nineteen '
    ];

    const b = [
        '', '', 'Twenty ', 'Thirty ', 'Forty ', 'Fifty ',
        'Sixty ', 'Seventy ', 'Eighty ', 'Ninety '
    ];

    if (!amount) return 'Zero';

    const num = Math.floor(amount);
    const decimal = Math.round((amount - num) * 100);

    if (num > 999999999) return amount.toString();

    const getTwoDigits = (n) => {
        if (n < 20) return a[n];
        return b[Math.floor(n / 10)] + a[n % 10];
    };

    const getThreeDigits = (n) => {
        let str = '';
        if (Math.floor(n / 100) > 0) {
            str += a[Math.floor(n / 100)] + 'Hundred ';
            if (n % 100) str += 'and ';
        }
        str += getTwoDigits(n % 100);
        return str;
    };
    
    let str = '';
    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num / 100000) % 100);
    const thousand = Math.floor((num / 1000) % 100);
    const hundred = num % 1000;
    if (crore) str += getTwoDigits(crore) + 'Crore ';
    if (lakh) str += getTwoDigits(lakh) + 'Lakh ';
    if (thousand) str += getTwoDigits(thousand) + 'Thousand ';
    if (hundred) str += getThreeDigits(hundred);
    str = str.trim();
    if (num > 0) {
        str += ' Rupees ';
    }
    if (decimal > 0) {
        if (num > 0) str += 'and ';
        str += getTwoDigits(decimal) + 'Paise ';
    }

    if (num === 0 && decimal === 0) return 'Zero Rupees Only';

    return str.trim() + ' Only';
};